import { render, staticRenderFns } from "./draggable_component.vue?vue&type=template&id=281295ab&scoped=true"
import script from "./draggable_component.vue?vue&type=script&lang=js"
export * from "./draggable_component.vue?vue&type=script&lang=js"
import style0 from "./draggable_component.vue?vue&type=style&index=0&id=281295ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281295ab",
  null
  
)

export default component.exports